import { Component } from 'react';

import TextUtils from './TextUtils';

class DateUtilities extends Component {

    // constructor(props) {
    //     super(props);
    // }
    getCurrentYear = () => {
        return new Date().getFullYear();
    }

    getFormattedDateTimeByTimeStamp = (timeStamp) => {
        if (TextUtils.isEmpty(timeStamp)) {
            return "N/A";
        }
        var date = new Date(timeStamp);
        var year = date.getFullYear();
        var m = date.getMonth() + 1;
        var month = m < 10 ? '0' + m : m;
        var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        var format = "AM";
        var hour = date.getHours();
        var minutes = date.getMinutes();

        if (hour > 11) {
            format = "PM";
        }
        if (hour > 12) {
            hour = hour - 12;
        } else if (hour === 0) {
            hour = 12;
        }

        if (hour < 10) {
            hour = "0" + hour;
        }

        if (minutes < 10) {
            minutes = "0" + minutes;
        }

        var finalDateString = day + "-" + month + "-" + year + " " + hour + ":" + minutes + " " + format;
        return finalDateString;
    }

    getFormattedDateByTimeStamp = (timeStamp) => {
        if (TextUtils.isEmpty(timeStamp)) {
            return "N/A";
        }
        var date = new Date(timeStamp);
        var year = date.getFullYear();
        var m = date.getMonth() + 1;
        var month = m < 10 ? '0' + m : m;
        var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        var finalDateString = day + "-" + month + "-" + year;
        return finalDateString;
    }

    getCalendarFormattedDateByTimeStamp = (timeStamp) => {
        if (TextUtils.isEmpty(timeStamp)) {
            return "N/A";
        }
        var date = new Date(timeStamp);
        var year = date.getFullYear();
        var m = date.getMonth() + 1;
        var month = m < 10 ? '0' + m : m;
        var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        var finalDateString = year + "-" + month + "-" + day;
        return finalDateString;
    }

    getFormattedDateTimeForDateTimeColumns = (timeStamp) => {
        if (TextUtils.isEmpty(timeStamp)) {
            return "N/A";
        }
        var date = new Date(timeStamp);
        var year = date.getFullYear();
        var m = date.getMonth() + 1;
        var month = m < 10 ? '0' + m : m;
        var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
        var format = "AM";
        var hour = date.getHours();
        var minutes = date.getMinutes();

        if (hour < 10) {
            hour = "0" + hour;
        }

        // if (hour > 11) {
        //     format = "PM";
        // }
        // if (hour > 12) {
        //     hour = hour - 12;
        // } else if (hour === 0) {
        //     hour = 12;
        // }

        // if (hour < 10) {
        //     hour = "0" + hour;
        // }

        if (minutes < 10) {
            minutes = "0" + minutes;
        }

        var finalDateString = year + "-" + month + "-" + day + " " + hour + ":" + minutes;
        return finalDateString;
    }
}

export default new DateUtilities();